import React from "react";
import styled from "styled-components";
import InfoIcon from "@icons/InfoIcon.svg";
import { BrowserUtil } from "@util/index";

const InfoIconButton = styled(InfoIcon)`
    fill: ${(props) => props.theme.iconColor};
    height: 18px;
    width: 18px;
    cursor: pointer;
`;

interface UserSettingItemProps {
    readonly label: string;
    /**
     * The component to use as the right hand side of the setting. If this prop is present, then
     * `inputType`, `inputValue`, `inputDefaultValue` should not be present. Else, all should be.
     */
    readonly inputComponent?: JSX.Element;
    readonly inputType?: "text" | "checkbox";
    readonly inputValue?: any;
    readonly inputDefaultValue?: any;
    readonly handleChange?: () => void;
    readonly moreInfoLink?: string;
}
export default function UserSettingItem(props: UserSettingItemProps) {
    const inputEl = props.inputComponent ? props.inputComponent : getInputElementForType(props);

    return (
        <div className={"user-setting"}>
            <span className={"setting-label"}>
                {props.label}
                {props.moreInfoLink && (
                    <InfoIconButton onClick={() => BrowserUtil.openLinkNewTab(props.moreInfoLink)} />
                )}
            </span>

            {inputEl}
        </div>
    );
}

const getInputElementForType = (info: UserSettingItemProps): JSX.Element => {
    let inputEl;
    switch (info.inputType) {
        case "text": {
            inputEl = (
                <input
                    className={"setting-input text"}
                    type="text"
                    value={info.inputValue || info.inputDefaultValue}
                    disabled
                />
            );
            break;
        }
        case "checkbox": {
            inputEl = (
                <input
                    className={`setting-input ${info.inputType}`}
                    type={"checkbox"}
                    checked={info.inputValue || false}
                    onChange={info.handleChange}
                />
            );
            break;
        }
        default: {
            inputEl = null;
            break;
        }
    }

    return inputEl;
};
